import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    <p>{`So sad to see you go.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`sudo npm uninstall npm -g
`}</code></pre>
    <p>{`Or, if that fails, get the npm source code, and do:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`sudo make uninstall
`}</code></pre>
    <h3>{`More Severe Uninstalling`}</h3>
    <p>{`Usually, the above instructions are sufficient.  That will remove
npm, but leave behind anything you've installed.`}</p>
    <p>{`If that doesn't work, or if you require more drastic measures,
continue reading.`}</p>
    <p>{`Note that this is only necessary for globally-installed packages.  Local
installs are completely contained within a project's `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{`
folder.  Delete that folder, and everything is gone less a package's
install script is particularly ill-behaved).`}</p>
    <p>{`This assumes that you installed node and npm in the default place.  If
you configured node with a different `}<inlineCode parentName="p">{`--prefix`}</inlineCode>{`, or installed npm with a
different prefix setting, then adjust the paths accordingly, replacing
`}<inlineCode parentName="p">{`/usr/local`}</inlineCode>{` with your install prefix.`}</p>
    <p>{`To remove everything npm-related manually:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`rm -rf /usr/local/{lib/node{,/.npm,_modules},bin,share/man}/npm*
`}</code></pre>
    <p>{`If you installed things `}<em parentName="p">{`with`}</em>{` npm, then your best bet is to uninstall
them with npm first, and then install them again once you have a
proper install.  This can help find any symlinks that are lying
around:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`ls -laF /usr/local/{lib/node{,/.npm},bin,share/man} | grep npm
`}</code></pre>
    <p>{`Prior to version 0.3, npm used shim files for executables and node
modules.  To track those down, you can do the following:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`find /usr/local/{lib/node,bin} -exec grep -l npm \\{\\} \\; ;
`}</code></pre>
    <h3>{`See also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-uninstall"
        }}>{`npm uninstall`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-prune"
        }}>{`npm prune`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      